import { Link } from 'react-router-dom';

export default function ArticleCTASection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-5">
            <i className="ri-file-text-line text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Kompletny poradnik Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto">
            Dowiedz się wszystkiego o Kakobuy Spreadsheet — jak działa, jak znaleźć
            najlepsze produkty, jak bezpiecznie zamawiać i oszczędzać czas.
            Przeczytaj nasz szczegółowy poradnik dla polskich użytkowników.
          </p>
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-poradnik"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line text-lg"></i>
            Przeczytaj pełny poradnik
          </Link>
        </div>
      </div>
    </section>
  );
}